import {
    MDBBadge,
    MDBBtn,
    MDBCol,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBRipple,
    MDBRow
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import Venmo from './../../venmo.png';
import zelle from './../../zelle.png';
import { CartContext } from '../context/CartProvider';

function ThankyouModal({ toggleThankyouModal, thankyouModal, setThankyouModal, handleSubmit }) {


  const { paymentInfo} = useContext(CartContext);


  return (
 

      <MDBModal open={thankyouModal} setOpen={setThankyouModal} tabIndex='-1' size='lg'>
        <MDBModalDialog>
          <MDBModalContent >
            <MDBModalHeader className='text-black bg-warning'>
              <MDBModalTitle>  <MDBIcon size='2x' icon='info' className='ml-1 me-2' fas /> Payment information </MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleThankyouModal}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBRow>
                <MDBRow>
                
                  <MDBCol>
                    <MDBRow className="align-items-center mt-3">

                      <img className="mr-2" src={Venmo} alt="Venmo" style={{ width: '80px', height: '20px' }} />
                      <a target="blank" rel="noopener noreferrer">{paymentInfo?.venmo}</a>


                    </MDBRow>
                    <MDBRow className="align-items-center mt-3">
                      <MDBIcon fab icon="paypal" style={{ color: '#3b5998' }} />
                      <a target="blank" rel="noopener noreferrer">{paymentInfo?.paypal}</a>

                    </MDBRow>
                    <MDBRow className="align-items-center mt-3">
                      <MDBCol md="4" className="d-flex align-items-center">
                        <img className="mr-2 " width="45px" src={zelle} alt="zelle" />
                      </MDBCol>
                      <MDBCol md="4" className="d-flex align-items-center">
                        <MDBRipple rippleTag='a' className="mr-2">
                          <MDBIcon size='3x' fas icon="money-check-alt" />
                          <div className='mask mt-4 text-light' style={{ marginLeft: '10px' }}>
                            check
                          </div>
                        </MDBRipple>
                      </MDBCol>
                      <MDBCol md="4" className="d-flex align-items-center">
                        <MDBRipple rippleTag='a' className="mr-2">
                          <MDBIcon size='3x' fas icon="money-bill" />
                          <div className='mask mt-4 text-light' style={{ marginLeft: '13px' }}>
                            cash
                          </div>
                        </MDBRipple>

                      </MDBCol>
                    </MDBRow>
                    <p className='mt-3'>Use this phone # <strong>{paymentInfo?.payPhone}</strong>  for all above </p>
                  </MDBCol>
                </MDBRow>
                <MDBRow className='d-flex justify-content-center justify-content-lg-between p-4 '>
                  <p>
                   {paymentInfo?.description}
                  </p>
                  <MDBCol>
                    <div className='fs-5'>
                      <p className='d-flex align-items-center'>Contact</p>
                      <MDBRow >
                        <MDBCol size='5'>
                          <MDBBadge pill color='warning'> {paymentInfo?.phoneRam} </MDBBadge>
                        </MDBCol>
                        <MDBCol size='2'>or</MDBCol>
                        <MDBCol size='5'>
                          <MDBBadge pill color='warning'> {paymentInfo?.phoneVidya} </MDBBadge>
                        </MDBCol>
                      </MDBRow>
                      <MDBRow className='mt-3'>
                        <MDBBadge pill color='warning'>{paymentInfo?.email}</MDBBadge>
                      </MDBRow>
                    </div>
                  </MDBCol>
                </MDBRow>
              </MDBRow>
            </MDBModalBody>
            <MDBModalFooter className='justify-content-center'>
              <MDBBtn color='warning' onClick={(e) => { toggleThankyouModal(); handleSubmit(e); }}>
                Continue
                <MDBIcon far icon='thumbs-up' className='ml-1 ms-2' />
              </MDBBtn>
              <MDBBtn color='link' outline onClick={toggleThankyouModal}>
                No, thanks
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
  
  );
}
ThankyouModal.propTypes = {
  toggleThankyouModal: PropTypes.func,
  thankyouModal: PropTypes.bool,
  setThankyouModal: PropTypes.func,
  handleSubmit: PropTypes.func,
}
export default ThankyouModal;